import React from 'react';

const AIFollowUp = ({ followUpQuestion, setFollowUpQuestion, handleFollowUpSubmit }) => {
    return (
        <div className="ai-summary-follow-up">
            <form onSubmit={handleFollowUpSubmit}>
                <input
                    type="text"
                    className="ai-summary-input"
                    placeholder="Ask your Microsoft question..."
                    value={followUpQuestion}
                    onChange={(e) => setFollowUpQuestion(e.target.value)}
                />
                <button type='submit' className='ai-summary-send-btn'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                        <rect width="38" height="38" rx="19" fill="#006AD6"/>
                        <mask id="mask0_18375_915" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="10" y="9" width="24" height="24">
                            <rect x="10" y="33" width="24" height="24" transform="rotate(-90 10 33)" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_18375_915)">
                            <path d="M19.8634 14.4131L19.8634 24.0426C19.8634 24.2873 19.7806 24.4924 19.6151 24.658C19.4495 24.8235 19.2444 24.9062 18.9997 24.9062C18.755 24.9062 18.5499 24.8235 18.3844 24.658C18.2189 24.4924 18.1361 24.2873 18.1361 24.0426L18.1361 14.4131L15.6747 16.8744C15.502 17.0472 15.3005 17.1299 15.0702 17.1227C14.8399 17.1155 14.6384 17.0328 14.4656 16.8744C14.2929 16.7017 14.2029 16.4966 14.1957 16.2591C14.1885 16.0216 14.2713 15.8165 14.444 15.6437L18.3952 11.6926C18.4815 11.6062 18.5751 11.5451 18.6759 11.5091C18.7766 11.4731 18.8846 11.4551 18.9997 11.4551C19.1149 11.4551 19.2228 11.4731 19.3236 11.5091C19.4243 11.5451 19.5179 11.6062 19.6043 11.6926L23.5554 15.6437C23.7281 15.8165 23.8109 16.0216 23.8037 16.2591C23.7965 16.4966 23.7065 16.7017 23.5338 16.8744C23.3611 17.0328 23.1596 17.1155 22.9293 17.1227C22.699 17.1299 22.4974 17.0472 22.3247 16.8744L19.8634 14.4131Z" fill="white"/>
                        </g>
                    </svg>
                </button>
            </form>
        </div>
    );
};

export default AIFollowUp;
